"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BufferedConsoleLogger = exports.ConsoleLogger = exports.CONSOLE = void 0;
const named_1 = require("./named");
exports.CONSOLE = console;
class ConsoleLogger extends named_1.NamedLogger {
    get implementation() { return exports.CONSOLE; }
}
exports.ConsoleLogger = ConsoleLogger;
class BufferedConsoleLogger {
    constructor(name) {
        this._name = null;
        this._logs = [];
        this._level = 1;
        this._log = exports.CONSOLE.log;
        this._name = name || '';
    }
    log(...args) {
        this._logs.push('\t--->', ...args);
    }
    warn(...args) {
        this._logs.push('\t---> [WARN]', ...args);
        this._raiseLevel(2);
    }
    error(...args) {
        this._logs.push('\t---> [ERROR]', ...args);
        this._raiseLevel(3);
    }
    flush() {
        if (this._logs.length > 0) {
            this._log(this._name, ...this._logs);
            this._logs.length = 0;
        }
    }
    _raiseLevel(l) {
        if (l > this._level) {
            this._level = l;
            if (l >= 3) {
                this._log = exports.CONSOLE.error;
            }
            else if (l >= 2) {
                this._log = exports.CONSOLE.warn;
            }
        }
    }
}
exports.BufferedConsoleLogger = BufferedConsoleLogger;
//# sourceMappingURL=console.js.map